import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import BaseLanguageProvider, { LanguageContext } from '@helsenorge/designsystem-react/utils/language';
import { selectCurrentLanguage } from '../../language';
import { CommonEvents } from '../../web-component/constants';
import { HNeventSendToMicrowebRoot, useEventListener } from '../../web-component/events';
/**
 * Hent nåværende språk fra context. Vær obs på at du selv må håndtere tilfeller der det ikke finnes tekster for dette språket,
 * for eksempel ved å bruke fallback til bokmål eller et annet språk.
 *
 * @returns LanguageContext
 */
export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
/**
 * LanguageProvider tilgjengeliggjør nåværende språk fra global redux-state i en React Context som benyttes
 * av komponenter som ikke har @helsenorge/core-framework eller @helsenorge/framework-utils som dependency.
 *
 * I komponenter som sendes inn som del av children, kan man bruke useLanguage-hooken for å lese ut språket.
 *
 * Kan bare brukes der Redux med global language state er i bruk.
 */
const LanguageProvider = props => {
    const currentLanguage = useSelector(state => selectCurrentLanguage(state.language));
    useEventListener(CommonEvents.microwebMounted, document, () => {
        HNeventSendToMicrowebRoot({ language: currentLanguage });
    });
    useEffect(() => {
        HNeventSendToMicrowebRoot({ language: currentLanguage });
    }, [currentLanguage]);
    return _jsx(BaseLanguageProvider, { language: currentLanguage, children: props.children });
};
export default LanguageProvider;
